import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function SocialProof() {
  const ref = useScrollAnimation();
  const stats = [{
    value: '+2.000',
    label: 'docentes confían'
  }, {
    value: '12',
    label: 'Tomos completamente listos'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '🇦🇷',
    label: 'Todo el país — primaria y secundaria'
  }];
  const miniTestimonials = [{
    initials: 'MG',
    quote: 'Organicé todo el año en una tarde',
    name: 'Mariela G., Córdoba | Primaria'
  }, {
    initials: 'LP',
    quote: 'Mis clases de secundaria por fin enganchan',
    name: 'Laura P., Rosario | Secundaria'
  }, {
    initials: 'RM',
    quote: 'Nunca más improvisé un acto',
    name: 'Roberto M., Buenos Aires | Primaria y Sec.'
  }];
  return <section className="w-full bg-[#141414] py-16 px-4 border-t border-[#1a1a1a]" ref={ref} data-id="element-188">
      <div className="max-w-6xl mx-auto" data-id="element-189">
        {/* Stats Row */}
        <div className="scroll-hidden grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-190">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-191">
              <div className="text-4xl md:text-5xl font-black text-[#F5C518] mb-2" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-192">
                {stat.value}
              </div>
              <p className="text-gray-300 text-sm md:text-base font-bold" data-id="element-193">
                {stat.label}
              </p>
            </div>)}
        </div>

        {/* Mini Testimonials */}
        <div className="scroll-hidden grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-194">
          {miniTestimonials.map((t, index) => <div key={index} className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-5 flex items-start gap-4" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-195">
              <div className="w-11 h-11 rounded-full bg-[#5a4a1a] flex items-center justify-center text-[#F5C518] font-black text-sm flex-shrink-0" data-id="element-196">
                {t.initials}
              </div>
              <div data-id="element-197">
                <div className="text-[#F5C518] text-sm mb-1" data-id="element-198">★★★★★</div>
                <p className="text-white font-medium text-sm leading-snug mb-1" data-id="element-199">
                  "{t.quote}"
                </p>
                <p className="text-gray-500 text-xs" data-id="element-200">— {t.name}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}